import type { Platform } from "@/types";

// Served from frontend/public/logos/. Vite/nginx expose /public as the site root.
const SRC: Record<Platform, string> = {
  myhome: "/logos/myhome.png",
  ss: "/logos/ss.svg",
};

const ALT: Record<Platform, string> = {
  myhome: "MyHome.ge",
  ss: "SS.ge",
};

type Size = "xs" | "sm" | "md" | "lg";

const HEIGHT: Record<Size, string> = {
  xs: "h-4",
  sm: "h-5",
  md: "h-6",
  lg: "h-8",
};

// Tailwind px values for the image plus chip padding. SS.ge's wordmark is
// black, so we always render on a translucent-white "glass" chip to keep the
// letters legible on the dark UI without overpowering it.
const CHIP_PADDING: Record<Size, string> = {
  xs: "px-1.5 py-0.5",
  sm: "px-2 py-1",
  md: "px-2.5 py-1.5",
  lg: "px-3 py-2",
};

export function PlatformLogo({
  platform,
  size = "sm",
  // MyHome's icon is a branded green house that reads fine on dark UI; SS.ge's
  // wordmark is black, so by default we wrap SS (only) in a frosted-white chip.
  chip = platform === "ss",
  className = "",
}: {
  platform: Platform;
  size?: Size;
  chip?: boolean;
  className?: string;
}) {
  const img = (
    <img
      src={SRC[platform]}
      alt={ALT[platform]}
      className={`${HEIGHT[size]} w-auto object-contain`}
      draggable={false}
    />
  );
  if (!chip) return <span className={className}>{img}</span>;
  return (
    <span
      className={`inline-flex items-center rounded-md bg-white/90 ring-1 ring-white/10 backdrop-blur-sm shadow-sm ${CHIP_PADDING[size]} ${className}`}
      title={ALT[platform]}
    >
      {img}
    </span>
  );
}

export function PlatformBadge({
  platform,
  size = "sm",
}: {
  platform: Platform;
  size?: Size;
}) {
  return <PlatformLogo platform={platform} size={size} chip />;
}

export function platformLabel(p: Platform): string {
  return ALT[p];
}
